<template>
  <b-modal
      id="modal-add-cliente-dkp"
      :title="cliente.id ? 'Atualizar Cliente' : 'Novo Cliente'"
      size="md"
      hide-footer
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      @close="onResetModel"
      @cancel="onResetModel"
  >
    <validation-observer ref="refFormCadastroClienteDKP">
      <b-form @reset="onResetModel">
        <b-row>
          <b-col cols="12">
            <b-form-group
                label="Nome Fantasia"
                label-for="nome"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Nome Fantasia"
                  rules="required"
              >
                <b-form-input
                    id="nome_fantasia"
                    v-model="cliente.nome_fantasia"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Nome Fantasia"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group
                label="Razão Social"
                label-for="razao_social"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Razão Social"
                  rules="required"
              >
                <b-form-input
                    id="razao_social"
                    v-model="cliente.razao_social"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Razão Social"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group
                label="CNPJ"
                label-for="cnpj"
            >
              <validation-provider
                  #default="{ errors }"
                  name="CNPJ"
                  rules="required|isCnpjValid"
              >
                <b-form-input
                    id="cnpj"
                    v-model="cliente.cnpj"
                    v-mask="'##.###.###/####-##'"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Ex.: XX.XXX.XXX/XXXX-XX"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group
                label="Subdomínio"
                label-for="subdominio"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Subdomínio"
                  rules="required"
              >
                <b-form-input
                    id="subdominio"
                    v-model="cliente.subdominio"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Subdomínio"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col cols="12" class="row justify-content-end px-0">
            <b-button
                variant="primary"
                @click="addClienteDkp"
            >
              {{ cliente.id ? 'Atualizar' : 'Cadastrar' }}
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </b-modal>
</template>

<script>
import {
  required, email, confirmed, url, between, alpha, integer, password, min, digits, alphaDash, length,
} from '@validations';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import { extend } from 'vee-validate';

extend('isCnpjValid', {
  validate: (value) => {
    const regexCnpj = /^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$/;
    return regexCnpj.test(value) || 'CNPJ inválido';
  },
});

export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      required,
      email,
      confirmed,
      url,
      between,
      alpha,
      integer,
      password,
      min,
      digits,
      alphaDash,
      length,
    };
  },
  computed: {
    cliente: {
      get() {
        return this.$store.getters['sisDkpClientes/GET_DKP_CLIENTE'];
      },
      set(val) {
        this.$store.commit('sisDkpClientes/SET_DKP_CLIENTE', val);
      },
    },
  },
  methods: {
    addClienteDkp() {
      this.$refs.refFormCadastroClienteDKP.validate()
        .then((success) => {
          if (success) {
            const regexCnpj = /^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$/;
            if (!regexCnpj.test(this.cliente.cnpj)) {
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: 'Erro',
                  text: 'CNPJ inválido',
                  icon: 'ErrorIcon',
                  variant: 'danger',

                },
              });
              return;
            }
            this.$bvModal.hide('modal-add-cliente-dkp');
            this.$emit('add-cliente-dkp', this.cliente);
          }
        });
    },
    onResetModel() {
      this.$refs.refFormCadastroClienteDKP.reset();
      this.$store.dispatch('sisDkpClientes/RESERT_DKP_CLIENTE');
    },
  },
};
</script>

<style scoped lang="scss">

</style>
